<div
  id="cobrowse-security-form"
  class="cobrowse-security-form"
  [class.cobrowse-sercurity-form-behind]="!cobrowseSecurityKeyWindowActive"
></div>
<basic-tooltip
  position="above"
  [ngClass]="cobrowseEnabled ? 'help-side' : 'help-top'"
  size="small"
  *ngIf="videoEngagerEnabled"
>
  <div label [ngClass]="cobrowseEnabled ? 'help-side' : 'help-top'">
    <button [ngClass]="cobrowseEnabled ? 'help-side__button' : 'help-top__button'" (click)="openChannelSelector()">
      <icon
        *ngIf="!channelSelectorActive"
        [ngClass]="cobrowseEnabled ? 'help-side__button__icon' : 'help-top__button__icon--video'"
        type="genesys-video-chat"
      ></icon>
      <icon *ngIf="channelSelectorActive" class="help-top__button__icon--close" type="close"></icon>
    </button>
  </div>
  <div tip>
    <p *ngIf="!channelSelectorActive">Video call</p>
    <p *ngIf="channelSelectorActive">Close</p>
  </div>
</basic-tooltip>
<basic-tooltip position="above" class="help-top" size="small" *ngIf="cobrowseEnabled">
  <div label class="help-top">
    <button class="help-top__button" (click)="openCobrowseSecurityForm()">
      <icon *ngIf="!cobrowseSecurityKeyWindowActive" class="help-top__button__icon" type="genesys-cobrowse"></icon>
      <icon *ngIf="cobrowseSecurityKeyWindowActive" class="help-top__button__icon--close" type="close"></icon>
    </button>
  </div>
  <div tip>
    <p *ngIf="!cobrowseSecurityKeyWindowActive">Input screen share code</p>
    <p *ngIf="cobrowseSecurityKeyWindowActive">Close</p>
  </div>
</basic-tooltip>
<basic-tooltip position="above" class="help-chat" size="small" *ngIf="webMessengerEnabled">
  <div label class="help-chat">
    <button class="help-chat__button" (click)="openMessenger()">
      <icon class="help-chat__button__icon" type="genesys-web-messenger"></icon>
    </button>
  </div>
  <div tip>
    <p>Chat support</p>
  </div>
</basic-tooltip>
